import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { API_BASE } from "../config";
import { plantelDeMatricula, idBDDesdePlantel } from "../utilities/plantel";
import Pdf from "../components/Pdf"; // Ajusta la ruta dependiendo de dónde guardes el hook

export const usePagoVentanilla = (alumno) => {
  const [cargandoPdf, setCargandoPdf] = useState(false);

  // Utilidad interna para evitar repetir el cálculo del Plantel
  const obtenerIdPlantelBD = () => {
    return idBDDesdePlantel(plantelDeMatricula(alumno.codigo));
  };

  const generarFolioTPV = () => {
    const idPlantelBD = obtenerIdPlantelBD().padStart(2, "0");
    const random4 = Math.floor(Math.random() * 10000).toString().padStart(4, "0");
    return `${idPlantelBD}${random4}`;
  };

  const guardarIntencionBD = async (
    conceptosGrupo,
    importe,
    refBanorte,
    refBBVA,
    folioRegistro = null,
    metodoEsperado = "VENTANILLA"
  ) => {
    const clavesConceptos = conceptosGrupo.map((item) => item.clave).join(", ");
    
    try {
      const response = await fetch(`${API_BASE}/wMultipagosGuardarIntencion.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          codigo_alumno: String(alumno.codigo),
          referencia_banorte: refBanorte,
          referencia_bbva: refBBVA || null,
          importe: importe,
          conceptos: conceptosGrupo,
          clave_concepto: clavesConceptos,
          id_plantel: obtenerIdPlantelBD(),
          metodo_esperado: metodoEsperado,
          folio_registro: folioRegistro,
        }),
      });
      return response.ok;
    } catch (error) {
      console.error("Error al guardar intención en BD:", error);
      return false;
    }
  };

  const descargarPdf = async (tablaConceptos, folioRegistro, fechaVencimiento) => {
    setCargandoPdf(true);
    try {
      const blob = await pdf(
        <Pdf
          name={alumno.nombre}
          code={alumno.codigo}
          table={tablaConceptos}
          folioRegistro={folioRegistro}
          fechaVencimiento={fechaVencimiento}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Orden de pago.pdf";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generando PDF:", error);
    } finally {
      setCargandoPdf(false);
    }
  };

  return {
    cargandoPdf,
    generarFolioTPV,
    guardarIntencionBD,
    descargarPdf,
  };
};